import {
  Button,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
} from '@mui/material';
import React, { useCallback, useId } from 'react';

interface IProps {
  open: boolean;
  title: string;
  message: string;
  onCancel: () => void;
  onConfirm: () => void;
  isDeleting?: boolean;
  confirmLabel?: string;
  cancelLabel?: string;
  dataAction?: string;
}

export const DeleteConfirmationDialog: React.FC<IProps> = ({
  open,
  title,
  message,
  onCancel,
  onConfirm,
  isDeleting = false,
  confirmLabel = 'Delete',
  cancelLabel = 'Cancel',
  dataAction,
}) => {
  const titleId = useId();
  const messageId = useId();

  const handleClose = useCallback(() => {
    if (!isDeleting) {
      onCancel();
    }
  }, [isDeleting, onCancel]);

  return (
    <Dialog
      open={open}
      onClose={handleClose}
      maxWidth="xs"
      fullWidth
      aria-labelledby={titleId}
      aria-describedby={messageId}
      data-action={dataAction}
    >
      <DialogTitle id={titleId}>{title}</DialogTitle>
      <DialogContent>
        <DialogContentText id={messageId}>{message}</DialogContentText>
      </DialogContent>
      <DialogActions>
        <Button
          variant="text"
          onClick={onCancel}
          disabled={isDeleting}
          data-action={dataAction ? `${dataAction}_cancel_btn` : undefined}
        >
          {cancelLabel}
        </Button>
        <Button
          variant="contained"
          color="error"
          onClick={onConfirm}
          disabled={isDeleting}
          startIcon={isDeleting ? <CircularProgress size={16} color="inherit" aria-label="Deleting" /> : undefined}
          data-action={dataAction ? `${dataAction}_confirm_btn` : undefined}
        >
          {confirmLabel}
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default DeleteConfirmationDialog;
